import { render, staticRenderFns } from "./TheHeading.vue?vue&type=template&id=3d3c2a6e&scoped=true&"
var script = {}
import style0 from "./TheHeading.vue?vue&type=style&index=0&id=3d3c2a6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3c2a6e",
  null
  
)

export default component.exports